export default "/auth/login/marketing-bg.png";